import { Event } from "@/models/Cart";
import { EventType } from "@/models/social";
import { trackPixelEvent } from "./facebook-pixel";

// Takes a generic social event and determines if it has a meta pixel
// and if so, tracks the event with the pixel
export const emitEvent = (event: Event, eventType: EventType, data: any) => {
  if (event.metaPixels) {
    event.metaPixels.forEach((pixel) => {
      if (pixel.pixelId) {
        trackPixelEvent(eventType, data);
      }
    });
  }
};
